module.exports = __webpack_public_path__ + "static/screenie_icon-750a72f289690a42f977217f469de5b3.webp";